let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9Oxgj")).then(() => parcelRequire('5L1ix'));